module.exports = __webpack_public_path__ + "img/pc-banner-hand.39a2e56d.png";